/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PaginatedResponseWithErrorGeneric } from '../shared/paginated-response-with-error-generic';
import { GetWarrantiesResponseJson } from './get-warranties-response-json';
import { GetWarrantiesResult } from '../results/get-warranties-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { EditWarrantyDto } from '../models/edit-warranty-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetWarrantiesResponse extends PaginatedResponseWithErrorGeneric<GetWarrantiesResponseJson, GetWarrantiesResult> implements IResponseWithErrorGeneric<GetWarrantiesResult> {
  public warranties: EditWarrantyDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetWarrantiesResponse>) {
    super(response, GetWarrantiesResult.Error);
    if (this.result !== GetWarrantiesResult.Success) {
      return;
    }

    this.warranties = this.body.warranties;
  }
  //</custom-body>
}
